export default __webpack_public_path__ + "static/media/RotateLeft.c72451cc.svg";